import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV === "development",
    fallbackLng: "ar",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          storiesForLife: "Stories for Life",
          stories: "Stories",
          submit: "Submit",
          message: "Message",
          name: "Name",
          male: "Male",
          female: "Female",
          gender: "Gender",
          country: "Country",
          city: "City or Region",
          contactUs: "Contact Us",
          whatsapp: "WhatsApp Number",
          termsAndConditions: "Terms & Conditions",
          privacyPolicy: "Privacy Policy",
          addToHomescreen: "Add to Home Screen",
          share: "Share Website",
        },
      },
      ar: {
        translation: {
          storiesForLife: "قصص للحياة",
          stories: "القصص",
          submit: "تسجيل",
          message: "الرسائل",
          name: ":الاسم",
          male: "ذكر",
          female: "انثى",
          gender: "الجنس",
          country: "البلد",
          city: ":المدينة أو المنطقة",
          contactUs: "تواصل معنا",
          whatsapp: "رقم الواتس اب",
          termsAndConditions: "الشروط والأحكام",
          privacyPolicy: "سياسية الخصوصية",
          addToHomescreen: "إضافة إلى الشاشة الرئيسية",
          share: "مشاركة الموقع",
        },
      },
    },
  });

export default i18n;
